import React, { useState } from "react";
import { limitText } from "../../Utility/Utility";
import TagManager from 'react-gtm-module';
import { Img } from "../../Components/UI/UI";

export const PromoMaterialsItem = (props) => {
  const href = props.href != undefined ? props.href : "";
  const image = props.image != undefined ? props.image : "";
  const imageHover = props.imageHover != undefined ? props.imageHover : "";
  const text = props.text != undefined ? props.text : "";
  const category = props.category != undefined ? props.category : "";
  const id = props.id != undefined ? props.id : "";
  const [isHover, setIsHover] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  let cancelCoverCss;

  if (isClicked) {
    cancelCoverCss = " ac-cover-hide";
  } else {
    cancelCoverCss = " ";
  }
  let urlImg;
  let hoverCss;
  if (isHover) {
    urlImg = imageHover;
    hoverCss = " ac-hover";
  } else {
    urlImg = image;
    hoverCss = " ";
  }

  return (
    <div
      className={
        "ac-wrapper-promomaterialsitem ac-wrapper-promomaterialsitem-" +
        id +
        hoverCss
      }
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="ac-promo-content">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={"ac-promo-link" + cancelCoverCss}
          onClick={()=> TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'link_click', 'element_location':'resources', 'click_cta':text, 'event_details':'Promotional Material',}})}
        >
          <Img desktopImg={urlImg} imgCss={"ac-cover-img"} />
        </a>
      </div>
      <p>{limitText(text, 100)}</p>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Components/PromoMaterials/PromoMaterialsItem.js